export function formatPercentage(value) {
  if (value == 0) {
    return "0%"
  }

  const formatted = value.toFixed(2)

  return `${formatted}%`
}
